module.exports = __webpack_public_path__ + "img/bg@2x.b39ae425.jpg";